import { ShoppingCart, SupportAgent } from "@mui/icons-material";
import About from "../pages/Website/Content/About";
import Contact from "../pages/Website/Content/Contact";
import Home from "../pages/Website/Content/Home";
import Products from "../pages/Website/Content/Products";
import Services from "../pages/Website/Content/Services";
import Sustainability from "../pages/Website/Content/Sustainability";
import DefaultConstants from "./Constants";

const NavBarLinks = [
    {
        path: '/',
        internal: true,
        name: 'home',
        component: Home
    }, {
        path: '/about',
        internal: true,
        name: 'about',
        component: About
    }, {
        path: '/products',
        internal: true,
        name: 'products',
        component: Products
    }, {
        path: '/services',
        internal: true,
        name: 'services',
        component: Services
    }, {
        path: '/contact',
        internal: true,
        name: 'contact',
        component: Contact
    }, {
        path: '/sustainability',
        internal: true,
        name: 'sustainability',
        component: Sustainability
    }
];


if (DefaultConstants.showStore) {
    NavBarLinks.push({
        path: 'https://loja.sagasystems.com.br/',
        internal: false,
        name: 'store',
        component: null,
        icon: ShoppingCart
    });
}

if (DefaultConstants.showTechnicalSupport) {
    NavBarLinks.push({
        path: 'https://sagasystems.tomticket.com/',
        internal: false,
        name: 'technicalSupport',
        component: null,
        icon: SupportAgent
    });
}

export default NavBarLinks;

